module.exports = __webpack_public_path__ + "img/earnDown.33d4062a.svg";